import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/index.css';
import App from './App.jsx';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import ErrorBoundary from './components/common/ErrorBoundary.jsx';

// Get dark mode from localStorage
const isDarkMode = localStorage.getItem('darkMode') === 'true' || 
                   localStorage.getItem('platformAdminDarkMode') === 'true';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
        <Toaster 
          position="top-right" 
          duration={3000} 
          richColors 
          theme={isDarkMode ? 'dark' : 'light'}
          toastOptions={{
            style: {
              background: isDarkMode ? '#1F2937' : '#FFFFFF',
              color: isDarkMode ? '#F9FAFB' : '#1F2937',
              border: isDarkMode ? '1px solid #374151' : '1px solid #E5E7EB',
            }
          }}
        />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
